import React, { useEffect, useState } from "react";
import { Payment_History } from '../../hooks/APIHooks';
import { FaMoneyBillWave, FaUser, FaCalendarAlt, FaDownload } from "react-icons/fa";
import { useAuth } from "../../hooks/GlobalProvider";
import NavbarAuth from "../../components/Navbar/Navbar_Auth";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import CSDLogo_2 from "../../assets/CSDLogo_2.png";

const PaymentHistory = () => {
  const { user } = useAuth();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        const response = await fetch(Payment_History);
        const data = await response.json();
        if (data.error) {
          setError(data.error);
        } else {
          setPayments(data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to fetch payment history");
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentHistory();
  }, []);

  const downloadInvoice = (payment) => {
    const doc = new jsPDF();
    const img = new Image();
    img.src = CSDLogo_2;

    img.onload = () => {
      doc.addImage(img, 'PNG', 14, 10, 30, 30);
      doc.setFontSize(18);
      doc.text("Cyber Space Digital | CSD", 50, 20);
      doc.setFontSize(12);
      doc.text("INVOICE", 160, 20);

      const invoiceNumber = `CSD${String(payment.id).padStart(6, '0')}`;
      const invoiceDate = new Date(payment.created_at).toLocaleDateString();

      autoTable(doc, {
        startY: 45,
        head: [["Invoice Number", "Invoice Date"]],
        body: [[invoiceNumber, invoiceDate]],
        styles: { fontSize: 10 }, theme: 'grid'
      });

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 5,
        head: [["Customer", "Phone"]],
        body: [[payment.name, payment.phone]],
        styles: { fontSize: 10 }, theme: 'grid'
      });

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        head: [["Item", "Qty", "Price", "Total"]],
        body: [["Subscription / Service", "1", `₹${payment.amount}`, `₹${payment.amount}`]],
        styles: { fontSize: 11 },
        headStyles: { fillColor: [22, 160, 133] }
      });

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 5,
        body: [
          ["Subtotal", `₹${payment.amount}`],
          ["Discount", "₹0.00"],
          ["Total", `₹${payment.amount}`],
          ["Status", payment.payment_status.toUpperCase()],
        ],
        styles: { fontSize: 11 },
        columnStyles: {
          0: { fontStyle: 'bold' },
          1: { halign: 'right' }
        },
        theme: 'plain'
      });

      doc.setFontSize(10);
      const y = doc.internal.pageSize.height - 30;
      doc.text("Thank you! Please visit us again!", 14, y);
      doc.text("Note: This is a computer-generated invoice.", 14, y + 6);
      doc.text("Generated by CRM GENI.in", 14, y + 12);

      doc.save(`Invoice_${invoiceNumber}.pdf`);
    };
  };

  if (loading) {
    return <div className="flex justify-center items-center min-h-screen text-gray-600">Loading payment history...</div>;
  }

  if (error) {
    return <div className="text-red-600 text-center font-medium mt-10">{error}</div>;
  }

  const userPayments = payments.filter(p => p.phone === user.phonenumber);

  return (
    <div> <NavbarAuth />
    <div className="p-4 sm:p-6 max-w-4xl mx-auto">
     
      {userPayments.length > 0 ? (
        <div className="space-y-4 mt-4">
          {userPayments.map(payment => (
            <div key={payment.id} className="border rounded-lg p-4 shadow-sm">
              <div className="flex items-center justify-between mb-2">
                <h2 className="text-base sm:text-lg font-semibold flex items-center gap-2">
                  <FaMoneyBillWave className="text-green-600" />
                  Transaction ID: {payment.txnid}
                </h2>
                <button
                  onClick={() => downloadInvoice(payment)}
                  className="flex items-center gap-2 px-3 py-1.5 bg-primary text-white rounded-md text-sm"
                >
                  <FaDownload />
                  Invoice
                </button>
              </div>
              <div className="text-sm space-y-1">
                <p className="flex items-center gap-2"><FaUser className="text-gray-600" /> {payment.name}</p>
                <p className="flex items-center gap-2"><FaCalendarAlt className="text-gray-600" /> {new Date(payment.created_at).toLocaleDateString()}</p>
                <p className="flex items-center gap-2">Phone: <span className="font-medium">{payment.phone}</span></p>
                <p className="flex items-center gap-2">Amount: <span className="font-medium">₹{payment.amount}</span></p>
                <p className="flex items-center gap-2">
                  Status:{" "}
                  <span className={`font-medium ${payment.payment_status === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                    {payment.payment_status}
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-600 text-lg mt-10">No payment history found for your phone number.</div>
      )}
    </div></div>
  );
};

export default PaymentHistory;
